import React, { useState } from 'react';
import StepPopup from './StepPopup';
import { InfoCircleFill } from 'react-bootstrap-icons';
import '../stylesheets/components/JourneySteps.css';

const steps = [
  {
    number: 1,
    title: 'Start',
    description: 'Send an invitation for a conversation to your team member or your manager. To do this, go to your Dashboard and click on “Create a conversation”.',
    colour: '#4CAF7D'
  },
  {
    number: 2,
    title: 'Email sent',
    description: 'After this, an email is sent to the person you invited.',
    colour: '#2E4A54'
  },
  {
    number: 3,
    title: 'Team member preparation',
    description: 'If you are the team member, you should complete your preparation at your convenience. Go to your dashboard and click on “Start”.',
    colour: '#0199A5'
  },
  {
    number: 4,
    title: 'Manager preparation',
    description: 'If you are the manager, prepare for the meeting at your convenience. You can look at the resources to learn more about the topics you and your team member may discuss during the conversation. Go to our Knowledge Hub and look at our Manager Preparation Guidance.',
    colour: '#379DD8'
  },
  {
    number: 5,
    title: 'Arrange your meeting',
    description: 'Schedule a meeting for the conversation. This should be done outside of the platform, using your standard diary system.',
    colour: '#1B437C'
  },
  {
    number: 6,
    title: 'Have your conversation',
    description: 'At the scheduled time, the manager launches the canvas to start the conversation. To do this, managers go to their Dashboard and click on “Start”.',
    colour: '#49B8B0'
  },
  {
    number: 7,
    title: 'Action',
    description: 'After your conversation, initiate the actions you agreed upon and review their progress. To review the agreed actions, go to your Dashboard and click on “View”.',
    colour: '#00938F'
  },
];

export default function JourneySteps() {
  const [openStep, setOpenStep] = useState(null);
  
  return (
    <div className="journey-container">
      <h2>
        Your Forward Together Journey
      </h2>
      <p className="fw-bold">
        Please see the user guide and training documents in the Knowledge Hub to get started.
        <br />
      </p>


      <div className="steps-row">
        {steps.map((step) => (
          <div key={step.number} className="step-block">
            <button
              className="step-button"
              style={{ backgroundColor: step.colour }}
              onClick={() => setOpenStep(step)}
            >
              <span className="step-label">Step {step.number}.</span>
              <span className="step-title">{step.title}</span>
            </button>
            <InfoCircleFill className="info-icon" />
          </div>
        ))}
      </div>

      <StepPopup step={openStep} onClose={() => setOpenStep(null)} />
    </div>
  );
}